export default __webpack_public_path__ + "static/media/preliminar042024.b504c56a.pdf";